<template>
  <div class="error-wrap">
    <section>
      <div class="error-code">
        <h1>요청하신 페이지를 찾을 수 없습니다.</h1>
        <p>404 Page not found.</p>
      </div>
    </section>
  </div>
</template>

<script>
import '/static/css/error.css'
export default {
  name: 'PageNotFound'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/error/PageNotFound.vue